import { CSSProperties } from "react";
import { TooltipProps } from "recharts";

export const chartTooltipStyles = {
  contentStyle: {
    backgroundColor: "#1a1a1a",
    border: "none",
    borderRadius: "8px",
    padding: "10px 14px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  } as CSSProperties,
  labelStyle: {
    color: "#faaa0a",
    fontSize: "13px",
    fontWeight: 600,
    marginBottom: "4px",
  } as CSSProperties,
  itemStyle: {
    color: "#ffffff",
    fontSize: "13px",
    fontWeight: 600,
    padding: "2px 0",
  } as CSSProperties,
};

// Custom tooltip for the "Progress Over Time" chart.
// The chart overlays three series at the same x-points (verified score,
// unverified score, and the dashed "Projected" connecting line), so the
// default tooltip lists multiple values per datapoint. We only ever want
// the single relevant score: "Verified Score" or "Unverified Score".
export const ProgressOverTimeTooltip = ({ active, payload, label }: TooltipProps<number, string>) => {
  if (!active || !payload || payload.length === 0) return null;

  // Prefer the verified score; otherwise show the unverified score.
  // Ignore the "connectingLine" series and any undefined values.
  const entry =
    payload.find((p) => p.dataKey === "score" && p.value != null) ??
    payload.find((p) => p.dataKey === "unverifiedScore" && p.value != null);

  if (!entry) return null;

  const seriesLabel = entry.dataKey === "score" ? "Verified Score" : "Unverified Score";
  const formattedDate = new Date(label as number).toLocaleString("en-AU", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <div style={chartTooltipStyles.contentStyle}>
      <div style={chartTooltipStyles.labelStyle}>{formattedDate}</div>
      <div style={chartTooltipStyles.itemStyle}>{`${seriesLabel}: ${entry.value}%`}</div>
    </div>
  );
};
